var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgStackoverflow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M126.32 103.14h14.21V160H12.59v-56.86h14.22v42.64h99.51v-42.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.3 98.91 69.82 14.67 2.93-13.96-69.82-14.68L42.3 98.9Zm9.24-33.43 64.68 30.12 6.02-12.93-64.68-30.12-6.02 12.93Zm17.9-31.73 54.83 45.66 9.13-10.97-54.83-45.65-9.13 10.96ZM104.83 0 93.38 8.52l42.58 57.25 11.45-8.52L104.83 0ZM41.02 131.57h71.08v-14.22H41.02v14.22Z"
}))));

export default SvgStackoverflow;